var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { setHasFinishedSignup } from '@popup/multichain/actions/has-finished-signup.actions';
import reducers from '@popup/multichain/reducers';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
// import {composeWithDevTools} from 'remote-redux-devtools';
import AccountUtils from '@popup/steem/utils/account.utils';
import ActiveAccountUtils from '@popup/steem/utils/active-account.utils';
import RpcUtils from '@popup/steem/utils/rpc.utils';
import LocalStorageUtils from 'src/utils/localStorage.utils';
// const composeEnhancers = composeWithDevTools({
//   realtime: true,
//   port: 8000,
// });
/* istanbul ignore next */
const store = createStore(reducers, 
/* preloadedState, */ applyMiddleware(thunk));
if (store.getState().steem) {
    let previousAccounts = store.getState().steem.accounts;
    let previousRpc = store.getState().steem.activeRpc;
    let previousActiveAccountName = (_a = store.getState().steem.activeAccount) === null || _a === void 0 ? void 0 : _a.name;
    let previousMk = store.getState().mk;
    let previousSteemEngineConfig = store.getState().steem.steemEngineConfig;
    /* istanbul ignore next */
    store.subscribe(() => {
        const { mk, steem: { accounts, activeRpc, activeAccount, steemEngineConfig }, hasFinishedSignup, } = store.getState();
        const saveChanges = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!AccountUtils.isAccountListIdentical(previousAccounts, accounts)) {
                if (previousAccounts.length === 0 &&
                    previousAccounts.length !== accounts.length &&
                    !hasFinishedSignup) {
                    yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.HAS_FINISHED_SIGNUP, true);
                    store.dispatch(setHasFinishedSignup(true));
                    // AnalyticsUtils.sendAddFirstAccountEvent();
                }
                previousAccounts = accounts;
                if (accounts.length !== 0) {
                    AccountUtils.saveAccounts(accounts, mk);
                }
            }
            if (previousRpc && previousRpc.uri !== (activeRpc === null || activeRpc === void 0 ? void 0 : activeRpc.uri) && activeRpc) {
                previousRpc = activeRpc;
                RpcUtils.saveCurrentRpc(activeRpc);
            }
            if (activeAccount && previousActiveAccountName !== activeAccount.name) {
                previousActiveAccountName = activeAccount.name;
                ActiveAccountUtils.saveActiveAccountNameInLocalStorage(activeAccount.name);
            }
            if (previousMk !== mk) {
                previousMk = mk;
                //        MkUtils.saveMkInLocalStorage(mk);
            }
            if (previousSteemEngineConfig &&
                steemEngineConfig &&
                (previousSteemEngineConfig.accountHistoryApi !==
                    steemEngineConfig.accountHistoryApi ||
                    previousSteemEngineConfig.rpc !== steemEngineConfig.rpc)) {
                previousSteemEngineConfig = steemEngineConfig;
                yield LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.STEEM_ENGINE_ACTIVE_CONFIG, steemEngineConfig);
            }
        });
        saveChanges();
    });
}
export { store };
